import React from "react";
import { useQuery } from "@tanstack/react-query";
import * as apiClient from "../api";

/**
 * Public sponsored slot. Fetches only currently-active sponsors for a placement
 * (backend already filters out expired/scheduled/inactive) and renders their
 * banners with a clear "Sponsorizzato" label. Renders nothing when empty.
 */
export const SponsorSlot = ({ placement, className = "" }) => {
  const { data: sponsors = [] } = useQuery({
    queryKey: ["sponsors", placement],
    queryFn: () => apiClient.getSponsors(placement),
  });
  if (!sponsors.length) return null;
  return (
    <section className={`max-w-7xl mx-auto px-4 sm:px-6 ${className}`} data-testid={`sponsor-slot-${placement}`}>
      <div className="flex items-center gap-2 mb-4">
        <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-slate-400">Sponsorizzato</span>
        <div className="h-px flex-1 bg-slate-100" />
      </div>
      <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-4">
        {sponsors.map((s) => {
          const inner = s.image_url ? (
            <img src={s.image_url} alt={s.company} className="max-h-14 max-w-[160px] object-contain opacity-80 hover:opacity-100 transition-opacity" />
          ) : (
            <span className="text-slate-500 font-heading font-semibold text-lg opacity-70 hover:opacity-100 transition-opacity">{s.company}</span>
          );
          return s.link_url ? (
            <a key={s.id} href={s.link_url} target="_blank" rel="noopener noreferrer" data-testid={`sponsor-item-${s.id}`}>{inner}</a>
          ) : (
            <div key={s.id} data-testid={`sponsor-item-${s.id}`}>{inner}</div>
          );
        })}
      </div>
    </section>
  );
};
